import { getCurrentInstance, computed } from 'vue'
import Throne from '../../../Throne'
import { CodeItem } from '../../types'
import { isArray, isString } from 'lodash-es'
import OrionError from '../../../error/OrionError'
import { useThroneContext } from '../../../Throne/hooks/use-throne-context'

const useInputCode = () => {
  const { props } = getCurrentInstance()!

  const throneContext = useThroneContext()

  return computed(() => {
    let codeData: Array<CodeItem>
    const { code } = props
    if (!code) {
      throw new OrionError('code为空')
    } else if (isString(code)) {
      codeData = Throne.getCode(code, throneContext?.value).value
    } else if (isArray<CodeItem>(code)) {
      codeData = code
    } else {
      throw new OrionError('code类型错误')
    }

    return codeData
  })
}

export { useInputCode }
